import { JobPostings } from '@platform/client';
import { DatePickerWithTimezone, Input, Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { JobPosting } from 'lib/client/src/platformapi.schemas';
import { useState } from 'react';

interface UpdateJobPostingModalProps {
  isOpen: boolean;
  onClose: () => void;
  jobPosting: JobPosting;
  page?: number;
  limit?: number;
}

export const UpdateJobPostingModal = (props: UpdateJobPostingModalProps) => {
  const { jobPosting, isOpen, onClose, page, limit } = props;

  const [title, setTitle] = useState(jobPosting.title);
  const [description, setDescription] = useState(jobPosting.description);
  const [date, setDate] = useState(new Date(jobPosting.date));
  const [url, setUrl] = useState(jobPosting.url || '');
  const [location, setLocation] = useState(jobPosting.location || '');

  const queryClient = useQueryClient();

  const submitJobPosting = JobPostings.useUpdateJobPosting({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: JobPostings.getGetJobPostingsAdminQueryKey({
            limit: limit || 0,
            page: page || 0,
          }),
        });
      },
    },
  });

  const updateJobPosting = () => {
    submitJobPosting.mutate({
      data: {
        id: jobPosting.id,
        title,
        description,
        date: date.toISOString(),
        url,
        location,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
    setTitle('');
    setDescription('');
    setDate(new Date());
    setUrl('');
    setLocation('');
  };

  return (
    <Modal
      variant='dialog'
      title='Update Job Posting'
      isOpen={isOpen}
      headerDivision='divider'
      ignoreExtraPadding={true}
      onClose={closeModal}
      primaryCTA={{
        text: 'Update Job Posting',
        callback: updateJobPosting,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          <Input
            label='Title'
            type='inline'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          ></Input>
          <Input
            label='Description'
            type='multiline'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Input label='URL' type='inline' value={url} onChange={(e) => setUrl(e.target.value)} />
          <Input
            label='Location'
            type='inline'
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
          <DatePickerWithTimezone date={date} setDate={(newDate) => setDate(newDate)} />
        </div>
      </div>
    </Modal>
  );
};
